var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { useState } from 'react';
import { css } from '@emotion/react';
import { isolateComponent, labelStyles, withModifier, } from '@zapier/style-encapsulation';
import { uniqueId } from '../../../utils/uniqueId';
import { TextInput } from '../TextInput';
const breakpoints = {
    tablet: 768,
    desktop: 1230,
};
const Styles = labelStyles('SubscriptionForm', {
    root: css `
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin: 0 auto;
    @media screen and (min-width: ${breakpoints.tablet}px) {
      margin: 0;
      flex-direction: row;
    }
  `,
    inputField: (fluidInput) => css `
    display: flex;
    text-align: left;
    ${fluidInput &&
        withModifier('fluid', css `
        flex: 1 100%;
        @media screen and (min-width: ${breakpoints.tablet}px) {
          flex: 2;
        }
      `)}
  `,
});
export const SubscriptionForm = (_a) => {
    var { inputIsFullWidth = true, fluidInput = false } = _a, props = __rest(_a, ["inputIsFullWidth", "fluidInput"]);
    const [id] = useState(props.inputId || uniqueId('SubscriptionForm-'));
    const [subscribedValue, setSubscribedValue] = useState('');
    const inputSize = 'small';
    const inputProps = {
        id,
        isDisabled: props.inputIsDisabled,
        isErrored: !!props.inputError,
        isRequired: props.inputIsRequired,
        isFullWidth: inputIsFullWidth,
        placeholder: props.placeholderText,
        ariaLabel: props.placeholderText,
        size: inputSize,
        onChange: (event) => setSubscribedValue(event.target.value),
    };
    return (isolateComponent("form", { onSubmit: () => { var _a; return (_a = props.onSubmit) === null || _a === void 0 ? void 0 : _a.call(props, subscribedValue); }, "data-testid": "subscription-form" },
        isolateComponent("div", { css: Styles.root },
            isolateComponent("div", { css: Styles.inputField(fluidInput) }, props.renderInput ? (props.renderInput(inputProps)) : (isolateComponent(TextInput, Object.assign({}, inputProps)))),
            props.renderButton({ size: 'small' }))));
};
//# sourceMappingURL=SubscriptionForm.js.map
// @zapier/design-system@6.1.0 (fd86aa2ab)
